module.exports = __webpack_public_path__ + "static/media/career-quiz-background-mobile.48d753ee.png";